(() => {
  const ROOT_ID = 'DharniyaAdExitPopup';
  const AD_SESSION_KEY = 'dharniya_ad_visitor_v2';
  const SHOWN_SESSION_KEY = 'dharniya_ad_exit_shown_v2';
  const CLICKED_SESSION_KEY = 'dharniya_ad_exit_clicked_v2';
  const HISTORY_KEY = 'dharniyaAdExitGuardV2';

  const init = () => {
    const root = document.getElementById(ROOT_ID);
    if (!root) return;

    const params = new URLSearchParams(window.location.search);
    const forceTest = params.get('dharniya_popup_test') === '1';
    const medium = (params.get('utm_medium') || '').trim().toLowerCase();
    const paidMediums = new Set([
      'cpc', 'ppc', 'paid', 'paid_social', 'paidsocial', 'paid-social',
      'display', 'retargeting', 'remarketing', 'social_paid', 'social-paid'
    ]);
    const paidClickIds = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'twclid'];
    const hasPaidSignal = paidMediums.has(medium) || paidClickIds.some((key) => params.has(key));

    if (hasPaidSignal) {
      try {
        sessionStorage.setItem(AD_SESSION_KEY, '1');
        if (params.get('utm_campaign')) sessionStorage.setItem('dharniya_ad_campaign_v2', params.get('utm_campaign'));
        if (params.get('utm_source')) sessionStorage.setItem('dharniya_ad_source_v2', params.get('utm_source'));
      } catch (_) {}
    }

    let isAdVisitor = hasPaidSignal || forceTest;
    let alreadyShown = false;
    let alreadyClicked = false;
    try {
      isAdVisitor = isAdVisitor || sessionStorage.getItem(AD_SESSION_KEY) === '1';
      alreadyShown = sessionStorage.getItem(SHOWN_SESSION_KEY) === '1';
      alreadyClicked = sessionStorage.getItem(CLICKED_SESSION_KEY) === '1';
    } catch (_) {}

    const designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && Shopify.designMode);
    const previewInEditor = root.dataset.previewInEditor === 'true';

    // Theme editor preview and ?dharniya_popup_test=1 intentionally ignore session suppression.
    if (!forceTest && !(designMode && previewInEditor)) {
      if (!isAdVisitor || alreadyShown || alreadyClicked) return;
    }

    const desktopEnabled = root.dataset.desktopEnabled === 'true';
    const mobileEnabled = root.dataset.mobileEnabled === 'true';
    const isMobileLike = window.matchMedia('(hover: none), (pointer: coarse)').matches || window.innerWidth < 750;
    let open = false;
    let mobileGuardArmed = false;

    const rememberShown = () => {
      if (forceTest || (designMode && previewInEditor)) return;
      alreadyShown = true;
      try { sessionStorage.setItem(SHOWN_SESSION_KEY, '1'); } catch (_) {}
    };

    const show = () => {
      if (open) return;
      if (!forceTest && !(designMode && previewInEditor) && (alreadyShown || alreadyClicked)) return;
      rememberShown();
      open = true;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dharniya-ad-exit-open');
      const closeButton = root.querySelector('.dharniya-ad-exit__close');
      if (closeButton) window.setTimeout(() => closeButton.focus({ preventScroll: true }), 20);
    };

    const close = () => {
      if (!open) return;
      open = false;
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dharniya-ad-exit-open');
    };

    root.querySelectorAll('[data-ad-exit-close]').forEach((button) => button.addEventListener('click', close));
    root.querySelectorAll('[data-ad-exit-product-link]').forEach((link) => {
      link.addEventListener('click', () => {
        try { sessionStorage.setItem(CLICKED_SESSION_KEY, '1'); } catch (_) {}
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && open) close();
    });

    // Guaranteed verification path for the store owner.
    if (forceTest || (designMode && previewInEditor)) {
      window.setTimeout(show, 450);
      return;
    }

    if (!isAdVisitor) return;

    if (!isMobileLike && desktopEnabled) {
      const exitHandler = (event) => {
        const leavingDocument = !event.relatedTarget && !event.toElement;
        const nearTop = typeof event.clientY === 'number' && event.clientY <= 12;
        if (leavingDocument && nearTop) {
          show();
          document.documentElement.removeEventListener('mouseout', exitHandler);
          document.removeEventListener('mouseout', exitHandler);
        }
      };

      // Attach to both roots because browsers differ in where the final mouseout lands.
      window.setTimeout(() => {
        document.documentElement.addEventListener('mouseout', exitHandler);
        document.addEventListener('mouseout', exitHandler);
      }, 900);
    }

    if (isMobileLike && mobileEnabled) {
      try {
        const currentState = history.state && typeof history.state === 'object' ? history.state : {};
        history.pushState({ ...currentState, [HISTORY_KEY]: true }, '', window.location.href);
        mobileGuardArmed = true;
      } catch (_) {}

      window.addEventListener('popstate', () => {
        if (mobileGuardArmed && !alreadyShown && !alreadyClicked) {
          mobileGuardArmed = false;
          show();
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
